import React, { forwardRef, HTMLProps } from "react";
import { motion } from "framer-motion";
import cn from "classnames";
import s from "./DesktopMenu.module.scss";

type Props = {
  title: string;
  index: number;
  isActive: boolean;
  onClick: () => void;
} & HTMLProps<HTMLDivElement>;

export const DesktopSubNavigationPanelDiv = forwardRef<HTMLDivElement, Props>(
  ({ title, isActive, index, onClick, ...anchorProps }, ref) => {
    const handleClick = () => {
      if (!isActive) {
        onClick();
      }
    };

    const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
      if (!isActive && (e.key === "Enter" || e.key === " ")) {
        onClick();
        e.preventDefault();
      }
    };

    return (
      <motion.li
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.2, delay: index * 0.03 }}
      >
        <div
          className={cn(
            s.DesktopSubNavigationPanelItem,
            s.DesktopSubNavigationPanelDiv,
            {
              [s.active]: isActive,
              [s.inactive]: !isActive,
            }
          )}
          onClick={handleClick}
          onKeyDown={handleKeyDown}
          role={isActive ? "none" : "button"}
          tabIndex={isActive ? -1 : 0}
          aria-disabled={isActive}
          ref={ref}
          {...anchorProps}
        >
          {title && <span>{title}</span>}
        </div>
      </motion.li>
    );
  }
);

DesktopSubNavigationPanelDiv.displayName = "DesktopSubNavigationPanelDiv";
